import ToastHighLighter from '@/lib/ToastHighLighter';

export const ProgressbarCode = () => {
  const language = 'html';
  const codeString = `
  // Progressbar

  // Progressbar striped
  <div
    class="progress mb-5"
    role="progressbar"
    aria-label="Animated striped example"
    aria-valuenow="10"
    aria-valuemin="0"
    aria-valuemax="100"
  >
    <div
      class="progress-bar progress-bar-striped progress-bar-animated"
      style={{ width: '10%' }}
    >
      10%
    </div>
  </div>

  // Colored progressbar
  <div class="progress mb-2">
    <div
      class="progress-bar bg-success"
      role="progressbar"
      aria-valuenow={10}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      10%
    </div>
  </div>
  <div class="progress mb-2">
    <div
      class="progress-bar bg-black"
      role="progressbar"
      style={{ width: '25%' }}
      aria-valuenow={25}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      25%
    </div>
  </div>
  <div class="progress mb-2">
    <div
      class="progress-bar bg-danger"
      role="progressbar"
      style={{ width: '50%' }}
      aria-valuenow={50}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      50%
    </div>
  </div>
  <div class="progress mb-2">
    <div
      class="progress-bar bg-success"
      role="progressbar"
      style={{ width: '75%' }}
      aria-valuenow={75}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      75%
    </div>
  </div>
  <div class="progress mb-2">
    <div
      class="progress-bar bg-warning text-black"
      role="progressbar"
      style={{ width: '100%' }}
      aria-valuenow={100}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      100%
    </div>
  </div>
  `;

  return (
    <>
      <ToastHighLighter
        name={'progressbar'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
